import {
    FETCH_PACK_ORDER_PENDING,
    FETCH_PACK_ORDER_SUCCESS,
    FETCH_PACK_ORDER_FAILED,
    FETCH_PACK_ORDER_ITEMS_PENDING,
    FETCH_PACK_ORDER_ITEMS_SUCCESS,
    FETCH_PACK_ORDER_ITEMS_FAILED,
    PACK_SCAN_RESULT,
    CLEAR_PACK_SCAN_RESULT,
    CLEAR_PACK_VERIFICATION
} from "../types";
import {
    getOrderByLabelService,
    getOrderItemsService,
    scanPackItemService,
    completePackVerificationService,
    resetPackVerificationService
} from "../../services/packVerification.service";

const fetchPackOrderPending = () => ({
    type: FETCH_PACK_ORDER_PENDING
});

const fetchPackOrderSuccess = (response) => ({
    type: FETCH_PACK_ORDER_SUCCESS,
    payload: response,
});

const fetchPackOrderItemsPending = () => ({
    type: FETCH_PACK_ORDER_ITEMS_PENDING
});

const fetchPackOrderItemsSuccess = (response) => ({
    type: FETCH_PACK_ORDER_ITEMS_SUCCESS,
    payload: response,
});

const fetchPackOrderFailed = () => ({
    type: FETCH_PACK_ORDER_FAILED
});

const fetchPackOrderItemsFailed = () => ({
    type: FETCH_PACK_ORDER_ITEMS_FAILED
});

const packScanResult = (response) => ({
    type: PACK_SCAN_RESULT,
    payload: response,
});

export const clearPackScanResult = () => ({
    type: CLEAR_PACK_SCAN_RESULT
});

export const clearPackVerification = () => ({
    type: CLEAR_PACK_VERIFICATION
});

export const getOrderByLabel = (data) => {
    return (dispatch) => {
        dispatch(fetchPackOrderPending());
        getOrderByLabelService(data).then((result) => {
            if (result?.data?.Status === 200 && result.data.Entity) {
                dispatch(fetchPackOrderSuccess(result.data.Entity));
            } else {
                dispatch(fetchPackOrderFailed());
            }
        }).catch((error) => {
            console.log(error);
            dispatch(fetchPackOrderFailed());
        });
    };
};

export const getOrderItems = (data) => {
    return (dispatch) => {
        dispatch(fetchPackOrderItemsPending());
        getOrderItemsService(data).then((result) => {
            if (result?.data?.Status === 200) {
                dispatch(fetchPackOrderItemsSuccess({
                    orderItems: result.data.EntityList || [],
                    TotalRecords: result.data.TotalRecords
                }));
            } else {
                dispatch(fetchPackOrderItemsFailed());
            }
        }).catch((error) => {
            console.log(error);
            dispatch(fetchPackOrderItemsFailed());
        });
    };
};

export const scanPackItem = (data) => {
    return (dispatch) => {
        return scanPackItemService(data).then((result) => {
            if (result?.data?.Status === 200) {
                dispatch(packScanResult(result.data.Entity));
            }
            return result;
        }).catch((error) => {
            console.log(error);
            return error;
        });
    };
};

export const completePackVerification = (data) => {
    return () => {
        return completePackVerificationService(data);
    };
};

export const resetPackVerification = (data) => {
    return () => {
        return resetPackVerificationService(data);
    };
};
